import React from 'react';

const PlusIcon = (props) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.4393 7.35537H8.86359V2.69421C8.86359 2.29752 8.4657 2 8.06781 2C7.66992 2 7.3715 2.29752 7.3715 2.69421V7.2562H2.69631C2.29842 7.35537 2 7.65289 2 8.04959C2 8.44628 2.29842 8.7438 2.69631 8.7438H7.27203V13.3058C7.27203 13.7025 7.57045 14 7.96834 14C8.16728 14 8.36623 13.9008 8.4657 13.8017C8.56517 13.7025 8.66464 13.5041 8.66464 13.3058V8.84298H13.2404C13.4393 8.84298 13.6383 8.7438 13.7377 8.64463C13.8372 8.54545 13.9367 8.34711 13.9367 8.14876C14.1356 7.65289 13.8372 7.35537 13.4393 7.35537Z" fill="#2A2B2B" />
  </svg>
);
export default PlusIcon;
